import { ofType } from "redux-observable";
import { debounceTime, mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";
import { GET_SCORING_DECISION_TEMPLATE } from "../types";

import {
  getScoringDecisionTemplatePending,
  getScoringDecisionTemplateFulfilled,
  getScoringDecisionTemplateRejected,
} from "../actions";

import { sendApiRequest, notifyError } from "../../../actions";

const createPayload = (payload) => ({
  method: "post",
  url: "localization/get",
  onSuccess: [getScoringDecisionTemplateFulfilled],
  onError: [
    getScoringDecisionTemplateRejected,
    () => {
      notifyError(
        "An error occurred while fetching the scoring decision template."
      );
    },
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getScoringDecisionTemplateEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_SCORING_DECISION_TEMPLATE.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getScoringDecisionTemplatePending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getScoringDecisionTemplateEpic$;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/getScoringDecisionTemplateEpic.js